<section class="sign-up-modal">
    <div class="left">
        <img src="/assets/imgs/sign-up-bg.png" style="height: 100%" />
    </div>
    <div class="right">
        <div class="mb-20">
            <app-general-modal-header
                [title]="'Brand Sign Up'"
                (cancel)="modalRef.triggerCancel()"
                [isBrandModal]="true"
            ></app-general-modal-header>
        </div>

        <form nz-form [formGroup]="validateForm" class="sign-up-form" (ngSubmit)="submitForm()">
            <div class="labels">Email</div>
            <nz-form-item>
                <nz-form-control [nzErrorTip]="emailEmptyErrorTpl">
                    <input type="text" nz-input formControlName="email" placeholder="Email" />
                    <ng-template #emailEmptyErrorTpl let-control>
                        <ng-container *ngIf="control.hasError('required')">
                            <span class="input-tip">Please enter your email address</span>
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <div class="labels">Password</div>
            <nz-form-item>
                <nz-form-control [nzErrorTip]="passwordEmptyErrorTpl">
                    <input type="password" nz-input formControlName="password" placeholder="Password" />
                    <ng-template #passwordEmptyErrorTpl let-control>
                        <ng-container *ngIf="control.hasError('minlength')">
                            <span class="input-tip">Short password!</span>
                        </ng-container>
                        <ng-container *ngIf="control.hasError('required')">
                            <span class="input-tip">Please enter your password</span>
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <div class="labels">Confirm Password</div>
            <nz-form-item>
                <nz-form-control [nzErrorTip]="confirmPasswordErrorTpl">
                    <input type="password" nz-input formControlName="confirm_password" placeholder="Confirm password" />

                    <ng-template #confirmPasswordErrorTpl let-control>
                        <ng-container *ngIf="control.hasError('notSame')">
                            <span class="input-tip">Passwords don't match</span>
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <div class="labels">Invitation Code <span>(Optional)</span></div>
            <nz-form-item>
                <nz-form-control [nzErrorTip]="invitationCodeErrorTpl">
                    <input type="text" nz-input formControlName="invitation_code" placeholder="Your invitation code" />
                    <ng-template #invitationCodeErrorTpl let-control>
                        <ng-container *ngIf="control.hasError('invalidCode')">
                            <span class="input-tip">{{control.getError('invalidCode')}}</span>
                        </ng-container>
                        <ng-container *ngIf="control.hasError('required')">
                            <span class="input-tip">Please input invitation code!</span>
                        </ng-container>
                    </ng-template>
                </nz-form-control>
            </nz-form-item>
            <div nz-row class="terms-of-use">
                <label nz-checkbox formControlName="terms_of_use">
                    <span style="margin-left: 5px">I agree to the</span>
                </label>
                <a href="/main/policy/terms-of-service" target="_blank">Terms of Use</a>
                <span style="padding: 0 5px">and</span>
                <a href="/main/policy/privacy-policy" target="_blank">Privacy Policy</a>
            </div>
            <div class="text-align-center">
                <button
                    nz-button
                    class="sign-up-form-button"
                    [nzType]="'primary'"
                    nzSize="large"
                    [nzLoading]="submitting"
                    [disabled]="invitationCode"
                >
                    SIGN UP
                </button>
            </div>
            <div class="text-align-center sign-in"><span>Already have an account?</span><a (click)="goSignIn()">Log In</a></div>
        </form>
    </div>
</section>
